"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openTelemetryIntegration = void 0;
var integrations_1 = require("./integrations");
Object.defineProperty(exports, "openTelemetryIntegration", { enumerable: true, get: function () { return integrations_1.openTelemetryIntegration; } });
//# sourceMappingURL=index.js.map